module.exports = __webpack_public_path__ + "img/notenoughdata-place-holder.50a8d633.png";